export type DriverKind = 'autoplay' | 'static'

/**
 * Reduced motion always wins. Everything else autoplays.
 *
 * Scroll-scrubbing was dropped deliberately: it pinned 320vh of page to run a
 * six-second demo, and it made the pace of the animation a function of how
 * fast someone happened to be turning the wheel.
 */
export function selectDriver(opts: { prefersReducedMotion: boolean }): DriverKind {
  return opts.prefersReducedMotion ? 'static' : 'autoplay'
}
